export const getPersoncompetences = ({
  competences: { personcompetences },
}) => {
  return personcompetences;
};

export const getCompetences = ({ competences: { competences } }) => {
  return competences;
};
